import BaseCom from "../BaseCom";
import L from "../Lang";
import './AppActions.css';

export default class AppActions extends BaseCom {
    render() {
        return <div className="app-actions">
            {this.props.showBack ? <button type="button" className="btn btn-lg btn-secondary d-block" onClick={this.goBack}><i className="fas fa-arrow-left"></i> <L>Back</L></button>
            : <div><button type="button" className="btn btn-lg btn-secondary d-block d-md-none" onClick={this.goBack}><i className="fas fa-arrow-left"></i> <L>Back</L></button></div>}
            {this.props.children}
        </div>
    }
}